var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,13l-8-5v10h9v2H4c-.6,0-1-.2-1.4-.6s-.6-.9-.6-1.4V6c0-.6.2-1,.6-1.4s.9-.6,1.4-.6h16c.6,0,1,.2,1.4.6s.6.9.6,1.4v7h-2v-5l-8,5ZM12,11l8-5H4l8,5ZM19,23l-1.4-1.4,1.6-1.6h-4.2v-2h4.2l-1.6-1.6,1.4-1.4,4,4-4,4ZM4,8v11-6h0v-7,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsg);
export default __webpack_public_path__ + "static/media/send-msg.90a0422b2eeeb6edd34333a19411fedd.svg";
export { ForwardRef as ReactComponent };